// extracted by mini-css-extract-plugin
export default {"notificationLink":"vOo5Jorfq2Mb3ZV23TEB"};